<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Inventory Mutation</h4>
          <div style="float: right">
          <vs-button @click="exportExcel">Export</vs-button>
        </div>
      </div>
      <div style="float: right" class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-right">
        
      </div>
    <div style="margin-top: 40px" class="vx-row">
      <div class="vx-col w-1/3">
      <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Client ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
              </div>
          </div>

          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Warehouse ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.warehouse_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, warehouse)"
                >
                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                </vs-select>
              </div>
          </div>
                  <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Posting Date</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                  <flat-pickr class="w-full" v-model="form.start" />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                  <flat-pickr class="w-full" v-model="form.end"/>
              </div>
                  </div>
        <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Product ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.product_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, product)"
                >
                    <vs-select-item v-for="(item, index) in product.data" :key="index" :value="item.id" :text="item.product_code"/>
                </vs-select>
              </div>
          </div>
      </div>
    </div>
      
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
  components: {
    vSelect,
    AgGridVue,
    flatPickr,
  },
   data() {
    return {
      gridOptions: {},
      gridApi: null,
      data: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      isLoading: false,
      form: {
        warehouse_id: null,
        product_id: null,
        client_id: null,
        picked:1,
      },
      warehouse: {
        data: [],
        loading: false,
        endpoint: 'master/warehouses',
        objectKey: 'warehouses_code'
      },
      product: {
        data: [],
        loading: false,
        endpoint: 'master/product',
        objectKey: 'product_code'
      },
      stock_type: {
        data: [],
        loading: false,
        endpoint: 'master/locationtypes',
        objectKey: 'code'
      },
      client: {
        data: [],
        loading: false,
        endpoint: 'master/clients',
        objectKey: 'client_code'
      },
      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("report/locationstatus", this.form)
        .then(() => {
          this.isLoading = false;
          this.form = {
            warehouse_id: null,
            location_id: null,
            client_id: null,
            location_type_id: null,
            section_id: null
          };
          this.$vs.notify({
            color: "success",
            title: "Data Added",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully Added"
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
     fetchData() {
      this.isLoading = true;
      Promise.all([
      this.$http.post("inventories/inventorieslist?page="+ this.currentPage),
      this.$http.post("master/warehouses"), 
      this.$http.post("master/product"), 
      this.$http.post("master/stocktypes"),
      this.$http.post("master/clients"),
      ])
        .then(
          this.$http.spread((resp, warehouse, product, stocktypes, client) => {
            this.data = resp.data.data;
            this.warehouse.data = warehouse.data.data;
            this.product.data = product.data.data;
            this.stock_type.data = stocktypes.data.data;
            this.client.data = client.data.data;
            this.totalPage = resp.data.last_page;
            this.currentPage = this.currentPage;
            this.dataTotal = resp.data.total;
            this.dataFrom = resp.data.from;
            this.dataTo = resp.data.to;
          })
        )
        .catch(() => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    exportExcel() {
      // this.currentPage = 1;
      this.fetchData();
      this.isLoading = true;
      this.$http
        .post("inventories/inventorieslist/report/download_excel", this.form, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "IM-Inventory.xlsx");
        });
    },
    
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
  this.columnDefs = [
    {
      headerName: "Warehouse Code",
      field: "warehouses_code",
      width: 150,
    }
  ];
}
};
</script>